<script lang="ts">import { cfgBrandTitle } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { InfoCard } from "@infinitro/info-card";
import VipSectionTitle from "./vip-section-title.svelte";
const BRAND_NAME = cfgBrandTitle();
</script>

<section class="why-join">
	<VipSectionTitle title={$t(Verbiage['vip_momentum_why_join_title'])} />
	<InfoCard width="100%" borderRadius="20px">
		<div class="why-join-content">
			<h3 class="headline">
				{$t(Verbiage['vip_momentum_play_more_earn_more'])}
			</h3>
			<div class="body">
				{@html $t(Verbiage['vip_momentum_intro']).replaceAll('[BRAND]', BRAND_NAME)}
			</div>
		</div>
	</InfoCard>
</section>

<style>
	.why-join {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 1rem
}
	.why-join-content {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
	.headline {
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 600
}
	.body {
    font-size: 0.875rem;
    line-height: 1.25rem;
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity, 1))
}
</style>
